export const blockIconsCommonactionsPriorityHighNew = (
	<span className='material-symbols-outlined'>priority_high</span>
);
